import React, {
  ReactElement, ReactNode, useState,
} from 'react';
import {
  Button, Col, FormGroup, Label, Row, Textarea, Text,
} from 'idsk-react-components';
import Definicia from '../../../../../model/Definicia';
import './legalnaDefiniciaItem.scss';
import { SafeParameterSetter } from '../../../../../model/SafeParameterSetter';
import VybratPredpis from './VybratPredpis';

interface Props {
  setItemList: (data: Definicia[]) => void;
  itemId: number;
  children: ReactNode;
  itemList: Array<Definicia>;
  getFieldErrorMessage: (fieldName: string) => string;
  clearFieldErrorMessage: (fieldName: string) => void;
  clearAllFieldErrorMessages: () => void;
}

const LegalnaDefiniciaItem = ({
  setItemList,
  itemId,
  children,
  itemList = [],
  clearFieldErrorMessage,
  getFieldErrorMessage,
  clearAllFieldErrorMessages,
}: Props): ReactElement => {
  const [definicia, setDefinicia] = useState<Definicia>(itemList[itemId]);

  const onRemove = (): void => {
    setItemList(itemList.filter((_, index) => index !== itemId));
    if (clearAllFieldErrorMessages) {
      clearAllFieldErrorMessages();
    }
  };

  const updateField: SafeParameterSetter<Definicia> = (fieldName, value) => {
    setDefinicia(prevState => ({ ...prevState, [fieldName]: value }));
    const newFormValues = [...itemList];
    newFormValues[itemId] = { ...definicia, [fieldName]: value };
    setItemList(newFormValues);
    if (clearFieldErrorMessage) {
      clearFieldErrorMessage(fieldName + itemId);
    }
  };

  return (
    <>
      <div className="legalna-definicia-item">
        <FormGroup>
          <Row>
            <Col width="two-thirds">
              <Label htmlFor="definicia">Legálna definícia</Label>
            </Col>
          </Row>
          <Row>
            <Col width="two-thirds">
              <Textarea
                name="definicia"
                value={definicia.definicia}
                onChange={({ target }) => updateField('definicia', target.value)}
                error={getFieldErrorMessage(`definicia${itemId}`)}
                maxLength={4096}
                rows={3}
                expandHeight
                showRemaining
              />
            </Col>
          </Row>
        </FormGroup>
        <FormGroup>
          <Row>
            <Col width="two-thirds">
              <Label htmlFor="zdroj">
                Legálny zdroj <span className="not-required"> (nepovinný údaj)</span>
              </Label>
              <Text className="legalna-definicia-zdroj-hint">Je možné vybrať konkrétny právny predpis.</Text>
            </Col>
          </Row>
          <Row>
            <Col width="two-thirds">
              <VybratPredpis
                definicia={definicia}
                setDefinicia={setDefinicia}
                setItemList={setItemList}
                itemId={itemId}
                itemList={itemList}
              />
            </Col>
          </Row>
        </FormGroup>

        {itemList.length > 0 && (
        <Row>
          <Col width="two-thirds">
            <Button
              type="button"
              size="large"
              className="remove-button"
              buttonStyle="negative"
              onClick={onRemove}
            >
              Zmazať definíciu
            </Button>
          </Col>
        </Row>
        )}
      </div>
      {children && definicia.definicia && definicia.definicia.trim().length > 0 && <>{children}</>}
    </>
  );
};

export default LegalnaDefiniciaItem;
